import { DoctorFormInputs } from './types';

export const formatDate = (date: Date | undefined) => {
  if (date) {
    const updatedDate = new Date(date);
    return updatedDate.toISOString();
  } else {
    return undefined;
  }
};

export const userProfileDataMapper = (data: DoctorFormInputs) => ({
  phoneNumber: data.phoneNumber,
  receiverType: 'email',
  mode: 'preregister',
  firstName: data.firstName,
  lastName: data.lastName,
  email: data.email,
  client_id: import.meta.env.VITE_DOCTOR_CLIENT_ID,
  roleType: 'Practitioner',
});

export const mapFormDataToApiFormat = (
  medplumId: string,
  data: DoctorFormInputs,
  imageUrl: string | null
): unknown => {
  const practitionerPatch = [
    {
      op: 'add',
      path: '/extension',
      value: [
        {
          url: 'https://fluentinhealth.com/fhir/StructureDefinition/PractitionerProfile',
          valueString: data.aboutMe,
        },
      ],
    },
    {
      op: 'replace',
      path: '/photo',
      value: [
        {
          contentType: 'image/png',
          url: imageUrl,
          title: 'Screenshot 2024-04-10 130722.png',
        },
      ],
    },

    {
      op: 'add',
      path: '/identifier',
      value: [
        {
          use: 'official',
          type: {
            coding: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
                code: 'MD',
                display: 'Medical License Number', // TODO: Hard code for now
              },
            ],
          },
          system: 'https://www.nmc.org.in/',
          value: data.registrationNumber,
          period: {
            start: formatDate(data.registrationValidity), // start date
            end: formatDate(data.registrationValidity), // You might want to add an end date field if needed
          },
          assigner: {
            reference: 'Organization/ec0b3664-6697-40c6-a1b6-7ad8ef2e6943',
            display: 'Fluent Health',
          },
        },
      ],
    },
    {
      op: 'add',
      path: '/name',
      value: [
        {
          given: [data.firstName],
          family: data.lastName,
          prefix: [data.prefix],
        },
      ],
    },
    {
      op: 'add',
      path: '/telecom',
      value: [
        {
          system: 'email',
          use: 'work',
          value: data.email,
        },
        {
          system: 'phone',
          use: 'mobile',
          value: data.phoneNumber,
        },
      ],
    },
    {
      op: 'add',
      path: '/address',
      value: [
        {
          city: data.city,
          country: data.country,
          address1: data.address1,
          address2: data.address2,
          state: data.state,
        },
      ],
    },
    {
      op: 'add',
      path: '/Practitioner',
      value: data.educationRows.map((row, index) => ({
        extension: [
          {
            url:
              index === 0
                ? 'https://fluentinhealth.com/fhir/StructureDefinition/PractitionerQualificationIsPrimary'
                : 'https://fluentinhealth.com/fhir/StructureDefinition/PractitionerQualificationIsYearOfExperience',
            valueBoolean: true,
          },
        ],
        code: {
          coding: [
            {
              system: 'http://terminology.hl7.org/CodeSystem/v2-0360|2.7',
              code: row.title,
              display: row.title,
            },
          ],
        },
        period: {
          start: row.years,
          end: row.years,
        },
        issuer: {
          reference: 'Organization/ec0b3664-6697-40c6-a1b6-7ad8ef2e6943',
          display: 'Fluent Health',
        },
      })),
    },
  ];

  const practitionerRole = {
    resourceType: 'PractitionerRole',
    practitioner: {
      reference: `Practitioner/${medplumId}`, // MedPlum id or practitioner id
      display: `${data.prefix ? data.prefix + '. ' : ''}${data.firstName} ${
        data.lastName
      }`,
    },
    active: true,
    period: {
      start: formatDate(data.practitionerStartDate),
      end: formatDate(data.practitionerEndDate),
    },
    specialty: [
      {
        coding: [
          {
            system: 'http://snomed.info/sct',
            code: data.specialization,
            display: data.specialization,
          },
        ],
      },
    ],
    code: [
      {
        coding: [
          {
            system: 'http://terminology.hl7.org/CodeSystem/practitioner-role',
            code: data.speciality,
            display: data.speciality,
          },
        ],
      },
    ],
  };

  return {
    resourceType: 'Bundle',
    type: 'transaction',
    entry: [
      {
        resource: {
          resourceType: 'Binary',
          contentType: 'application/json-patch+json',
          data: btoa(JSON.stringify(practitionerPatch)),
        },
        request: {
          method: 'PATCH',
          url: `Practitioner/${medplumId}`, // This should be dynamic
        },
      },
      {
        resource: practitionerRole,
        request: {
          method: 'POST',
          url: 'PractitionerRole',
        },
      },
    ],
  };
};
